module.exports = __webpack_public_path__ + "img/whatsapp.ad174663.svg";